'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var layout = _ref.layout,
        i18n = _ref.i18n;

    // Load Favorite textfield
    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
        nameTextField = _getFavoriteTextCmp.nameTextField,
        descriptionTextField = _getFavoriteTextCmp.descriptionTextField,
        titleTextField = _getFavoriteTextCmp.titleTextField;

    // Customise them for translate Panel


    delete nameTextField.height;
    delete titleTextField.height;
    delete descriptionTextField.height;

    nameTextField.emptyText = i18n.no_translation_for_name;

    if (!layout.title) {
        titleTextField['disabled'] = true;
        titleTextField.emptyText = i18n.no_title;
    } else {
        titleTextField.emptyText = i18n.no_translation_for_title;
    }

    if (!layout.description) {
        descriptionTextField['disabled'] = true;
        descriptionTextField.emptyText = i18n.no_description;
    } else {
        descriptionTextField.emptyText = i18n.no_translation_for_description;
    }

    // Create labels for keys
    var getLabelKey = function getLabelKey(text) {
        return Ext.create('Ext.panel.Panel', {
            style: 'margin-bottom:0',
            bodyStyle: 'font-size:11px; color:#666; padding-left:6px; padding-top:3px; border:0 none',
            html: text
        });
    };

    var nameLabelKey = getLabelKey(layout.name);
    var titleLabelKey = getLabelKey(layout.title);
    var descriptionLabelKey = getLabelKey(layout.description);

    return {
        nameTextField: nameTextField,
        nameLabelKey: nameLabelKey,
        titleTextField: titleTextField,
        titleLabelKey: titleLabelKey,
        descriptionTextField: descriptionTextField,
        descriptionLabelKey: descriptionLabelKey
    };
};

var _FavoriteTextCmp = require('./FavoriteTextCmp');

var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=TranslateTextCmp.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/TranslateTextCmp.js
 ** module id = 172
 ** module chunks = 0 1
 **/